import { ajax } from 'rxjs/ajax';
export function fetchShare(slug) {
    var url = "/api/shares/" + slug + "/";
    return ajax.getJSON(url);
}
